"use client";

const _excluded = ["size"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React from "react";
import BaseIcon from "../../utils/BaseIcon";
const ExternalLinkSystemIcon = props => {
  const {
      size = 24
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    size: size
  }, otherProps, {
    "data-mesh-component": "EXTERNAL-LINK-SYSTEM-ICON"
  }), /*#__PURE__*/React.createElement("path", {
    fill: iconFill,
    fillRule: "nonzero",
    d: "M11.251 4.498a.75.75 0 0 1 .102 1.493l-.102.007h-9a.75.75 0 0 0-.743.648l-.007.102v15c0 .38.282.693.648.743l.102.007h15a.75.75 0 0 0 .743-.648l.007-.102v-9a.75.75 0 0 1 1.493-.102l.007.102v9a2.25 2.25 0 0 1-2.096 2.245l-.154.005h-15a2.25 2.25 0 0 1-2.245-2.096l-.005-.154v-15a2.25 2.25 0 0 1 2.096-2.245l.154-.005zm12-4.5h.017c.02 0 .04.002.06.004za.754.754 0 0 1 .601.301l-.07-.081a.753.753 0 0 1 .212.428l.007.102v6.75a.75.75 0 0 1-1.493.102l-.007-.102-.001-4.939-13.719 13.72a.75.75 0 0 1-1.133-.977l.073-.084 13.718-13.72h-4.938a.75.75 0 0 1-.743-.648L15.75.748a.75.75 0 0 1 .648-.743l.102-.007z"
  }));
};
ExternalLinkSystemIcon.displayName = "ExternalLinkSystemIcon";
ExternalLinkSystemIcon.iconName = "ExternalLink";
export default ExternalLinkSystemIcon;